import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.records');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-records',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.records/view.scss */
:host {
  display: block;
  height: 100%;
}

.records-mood-option {
  justify-content: flex-start;
  gap: 6px;
  min-height: 92px;
}

.records-mood-icon-slot {
  flex: 0 0 2.5rem;
  line-height: 0;
}

.records-mood-face {
  display: block;
  flex: 0 0 1.5rem;
  width: 1.5rem;
  height: 1.5rem;
}

.records-mood-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 2.9em;
  line-height: 1.45;
  text-align: center;
}`],
})
export class PageRecordsComponent implements OnInit {
    public activeView: string = 'input';
    public today: string = '';

    public record: any = {
        steps: '',
        sleepHours: '',
        stepsMode: 'auto',
        sleepMode: 'auto',
        meals: true,
        alcohol: false,
        mood: 'normal'
    };

    public moodOptions: any[] = [
        { id: 'great', label: '매우 좋음', icon: 'great' },
        { id: 'good', label: '좋음', icon: 'good' },
        { id: 'normal', label: '보통', icon: 'normal' },
        { id: 'bad', label: '나쁨', icon: 'bad' },
        { id: 'terrible', label: '매우 나쁨', icon: 'terrible' }
    ];

    public recentRecords: any[] = [];
    public saving: boolean = false;
    public samsungHealthConnected: boolean = false;
    public healthSyncMessage: string = '삼성 헬스 미연동';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const now = new Date();
        this.today = `${now.getMonth() + 1}월 ${now.getDate()}일`;
        await this.loadToday();
        await this.loadSamsungHealthData();
        await this.service.render();
    }

    public async loadToday() {
        let res = await wiz.call("load_today");
        if (res.code === 200 && res.data) {
            this.record.steps = res.data.steps || '';
            this.record.sleepHours = res.data.sleep_hours || '';
            this.record.stepsMode = res.data.steps_mode || 'auto';
            this.record.sleepMode = res.data.sleep_mode || 'auto';
            this.record.meals = res.data.meals !== false;
            this.record.alcohol = res.data.alcohol === true;
            this.record.mood = res.data.mood || 'normal';
        }
    }

    public async switchView(view: string) {
        this.activeView = view;
        if (view === 'calendar') {
            await this.loadHistory();
        }
        await this.service.render();
    }

    public async loadSamsungHealthData() {
        if (this.record.stepsMode !== 'auto' && this.record.sleepMode !== 'auto') {
            return;
        }

        try {
            let res = await wiz.call("samsung_health_data");
            const data = res && res.code === 200 && res.data ? (res.data.data || res.data) : null;
            this.samsungHealthConnected = !!(data && data.connected);

            if (!this.samsungHealthConnected) {
                this.healthSyncMessage = '삼성 헬스 미연동';
                if (this.record.stepsMode === 'auto' && !this.record.steps) this.record.steps = 0;
                if (this.record.sleepMode === 'auto' && !this.record.sleepHours) this.record.sleepHours = 0;
                return;
            }

            if (this.record.stepsMode === 'auto') {
                this.record.steps = Number(data.steps) || 0;
            }

            if (this.record.sleepMode === 'auto') {
                this.record.sleepHours = Number(data.sleep_hours) || 0;
            }

            this.healthSyncMessage = data.last_sync ? `${data.last_sync} 동기화` : '삼성 헬스 동기화';
        } catch {
            this.samsungHealthConnected = false;
            this.healthSyncMessage = '동기화 실패';
        }
    }

    public async loadHistory() {
        let res = await wiz.call("history");
        if (res.code === 200 && res.data && Array.isArray(res.data)) {
            this.recentRecords = res.data;
        } else {
            this.recentRecords = [];
        }
        await this.service.render();
    }

    public async saveRecord() {
        this.saving = true;
        await this.service.render();

        let res = await wiz.call("save", {
            steps: this.record.steps || '0',
            sleepHours: this.record.sleepHours || '0',
            stepsMode: this.record.stepsMode,
            sleepMode: this.record.sleepMode,
            meals: String(this.record.meals),
            alcohol: String(this.record.alcohol),
            mood: this.record.mood
        });

        this.saving = false;
        await this.service.render();
    }

    public async selectMood(id: string) {
        this.record.mood = id;
        await this.service.render();
    }

    public async toggleMeals() {
        this.record.meals = !this.record.meals;
        await this.service.render();
    }

    public async toggleAlcohol() {
        this.record.alcohol = !this.record.alcohol;
        await this.service.render();
    }

    public async toggleStepsMode() {
        this.record.stepsMode = this.record.stepsMode === 'auto' ? 'manual' : 'auto';
        if (this.record.stepsMode === 'auto') {
            await this.loadSamsungHealthData();
        } else {
            this.record.steps = '';
        }
        await this.service.render();
    }

    public async toggleSleepMode() {
        this.record.sleepMode = this.record.sleepMode === 'auto' ? 'manual' : 'auto';
        if (this.record.sleepMode === 'auto') {
            await this.loadSamsungHealthData();
        } else {
            this.record.sleepHours = '';
        }
        await this.service.render();
    }
}

export default PageRecordsComponent;